"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _changeTab = require("./changeTab");
Object.keys(_changeTab).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeTab[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeTab[key];
    }
  });
});